import { render, staticRenderFns } from "./BattleTape.vue?vue&type=template&id=4f08bf50&"
import script from "./BattleTape.vue?vue&type=script&lang=ts&"
export * from "./BattleTape.vue?vue&type=script&lang=ts&"
import style0 from "./BattleTape.vue?vue&type=style&index=0&id=4f08bf50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports